var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation-field"},[_c('b-field',{attrs:{"label":_vm.label,"type":_vm.type,"message":_vm.message,"custom-class":_vm.sizeClass},on:{"focus":_vm.focussed}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }